import { Card } from '@ps/sports-ui-component-library';
import React from 'react';

import styles from './Promotion.scss';

export const Promotion: React.FC = ({ children }) => (
  <Card className={styles.promo}>{children}</Card>
);

export default Promotion;
